import React, { useEffect, useState, useRef } from 'react';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

import { firebaseFireStore } from '../../config/firebaseFirestore';

const ReactJkMusicPlayer = dynamic(() => import('react-jinke-music-player'), {
  ssr: false,
});

export default function AudioPlayer(props) {
  const router = useRouter();
  const [audioLists, setaudioLists] = useState([]);

  const { ele } = props;

  useEffect(() => {
    if (
      props.nftData &&
      props.nftData.icons &&
      props.nftData.icons.length > 0 &&
      props.artistDetails
    ) {
      let cArr = [];
      props.nftData.icons.map((a, b) => {
        cArr.push({
          musicSrc: a,
          cover:
            props.nftData &&
            props.nftData.audioCoverFile1500 &&
            props.nftData.audioCoverFile1500[0]
              ? props.nftData.audioCoverFile1500[0]
              : '',
          singer: props.artistDetails.name ? props.artistDetails.name : '',
          name:
            props.nftData.audioFileNames && props.nftData.audioFileNames[b]
              ? props.nftData.audioFileNames[b]
              : 'unknown',
        });
      });
      setaudioLists(cArr);
    }
  }, [props.nftData, props.artistDetails]);

  const customDownloader = async (downloadInfo) => {
    await fetch(downloadInfo.src)
      .then((response) => response.blob())
      .then((blob) => {
        var link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download =
          audioLists &&
          audioLists[props.audioIndex] &&
          audioLists[props.audioIndex].name
            ? audioLists[props.audioIndex].name
            : 'file';
        link.click();

        document.body.removeChild(link);
      })
      .catch(console.error);
  };

  return (
    <>
      <ReactJkMusicPlayer
        audioLists={audioLists}
        defaultPosition={{ bottom: 30, right: 30 }}
        preload={true}
        autoPlay={false}
        showDownload={false}
        getAudioInstance={(instance) => {
          props.audioInstance.current = instance;
        }}
        onAudioPause={() => {
          props.setaudioPlaying(false);
        }}
        onAudioPlay={() => {
          props.setaudioPlaying(true);
        }}
        onPlayIndexChange={(newIndx) => {
          props.setaudioIndex(newIndx);
        }}
        mode={props.audioPlayerMode}
        remove={false}
        // customDownloader={customDownloader}
      />
    </>
  );
}
